<template>
  <div class="login">
    <div class="logo">
      <logo></logo>
    </div>
    <div class="login-content">
      <div class="login-content__title">个人账户登录</div>
      <div class="login-content-info">
        <div class="login-content-line"
          v-for="item in userLoginShowInputData"
          :key="item.data">
          <div class="login-content-line__item">
            <input class="login-content-line__input"
              :class="{
                'login-content-line__input--verityCode': item.type === 'verityCode',
                'login-content-line__input--verityPhone': item.type === 'verityPhone',
                }"
              :type="item.type"
              v-model="userLoginData[item.data]"
              :placeholder="item.pla">
            <template v-if="item.type === 'verityPhone'">
              <template v-if="phoneCodeTime == 0">
                <div class="login-content-line__btn" @click="getPhoneLoginCode()">点击发送</div>
              </template>
              <template v-else>
                <div class="login-content-line__btn">{{ phoneCodeTime }}S</div>
              </template>
            </template>
            <template v-if="item.type === 'verityCode'">
              <img
                :src="userLoginData.verityImgUrl"
                alt="验证码"
                @click="switchVerityImg()"
                class="login-content-line__img">
            </template>
          </div>
        </div>
      </div>
      <div class="login-content-fun">
        <div class="login-content-fun__item" @click="changeForgetPasswordDialog(true)">忘记密码</div>
        <!-- <div class="login-content-fun__item" @click="switchPage('/registed123456')">免费注册</div> -->
      </div>
      <div class="login-content__btn" @click="loginBtnClick()">登录</div>
    </div>
    <copyright></copyright>
    <my-dialog
      :show="forgetPasswordDialogShow"
      title="找回密码"
      @cancel="changeForgetPasswordDialog">
      <div class="login-findpassword">
        <div class="login-findpassword-menu">
          <div
            class="login-findpassword-menu__item"
            v-for="item in forgetPasswordMenu"
            @click="forgetPasswordMenuItemClick(item.id)"
            :class="{'login-findpassword-menu__item--select': forgetPasswordMenuSelect == item.id}"
            :key="item.id">
            {{ item.name }}
          </div>
        </div>
        <div class="login-findpassword-input">
          <div class="login-findpassword-line"
            v-for="(item, index) in forgetPasswordInputData"
            :key="item.obj">
            <div class="login-findpassword__name">{{ item.name }}</div>
            <input
              class="login-findpassword__input"
              :class="{'login-findpassword__input--verity': index == 1}"
              :type="item.type"
              v-model="userLoginData[item.data]">
            <template v-if="index == 1">
              <template v-if="forgetPasswordTime == 0">
                <div class="login-findpassword-line__btn" @click="getForgetPasswordCode()">点击发送</div>
              </template>
              <template v-else>
                <div class="login-findpassword-line__btn">{{ forgetPasswordTime }}S</div>
              </template>
            </template>
          </div>
        </div>
        <div class="login-findpassword-bottom">
          <div class="login-findpassword__btn" @click="submitForgetPassword">提交</div>
        </div>
      </div>
    </my-dialog>
  </div>
</template>

<script>
  import copyright from "@/components/content/copyright";
  import logo from "@/components/content/logo";
  import Dialog from "@/components/common/Dialog";
  import { UserInputNewModule, UserLogin } from 'common/dataClass/User'
  import UserAxios from 'service/user'

  export default {
    name: "login",
    components: {
      'copyright': copyright,
      logo,
      'my-dialog': Dialog,
    },
    methods: {
      /**点击切换验证码 */
      switchVerityImg(){
        this.userLoginData.switchVerityImg()
      },
      /**登录按钮点击事件 */
      async loginBtnClick(){
        let bool = this.userLoginData.judgeIsLogin(this.isNeedPhoneCode)
        let data = this.userLoginData.getLoginAxiosBody
        if(!bool){
          this.$message.error('请将数据补充完整')
          return
        }
        const loading = this.$loading({
          lock: true,
          text: '登录中，请稍后',
          fullscreen: true
        })
        let dealObjFun = {
          1 : async () => {
            this.$message({ type: 'success', message: '登录成功' })
            await this.$store.dispatch('updateStoreList')
            this.$router.replace('/summary')
          },
          1001: (res) => {
            this.$message.error(res.data.info)
            this.$router.replace('/index')
          },
          1020: () => {
            sessionStorage.removeItem("JSESSIONID");
            sessionStorage.clear();
          },
          1041: () => {
            this.isNeedPhoneCode = true
            this.getPhoneLoginCode()
          },
          10001: (res) => {
            this.$message.error(res.data.info)
            this.$router.replace('/index')
          },
          error: (res) => {
            this.switchVerityImg()
            this.$message.error(res.data.info)
          }
        }
        let res = await UserAxios.login(data)
        let code = res.data.code;
        (dealObjFun[code] ? dealObjFun[code] : dealObjFun['error'])(res)
        loading.close()
      },
      /**获取手机登录验证码 */
      async getPhoneLoginCode(){
        let data = this.userLoginData.getPhoneLoginCodeAxiosBody
        let res = await UserAxios.getPhoneLoginCode(data)
        if(res.data.code === 1){
          this.phoneCodeTime = 60
          this.$message.success('请在60S内填写')
          this.phoneCodeTimer = setInterval(() => {
            if(this.phoneCodeTime > 0 && this.phoneCodeTime <= 60){
              this.phoneCodeTime --
            }else{
              clearInterval(this.phoneCodeTimer)
              this.phoneCodeTimer = null
            }
          }, 1000)
        }else{
          this.phoneCodeTime = 0
          this.phoneCodeTimer = null
          this.$message.error(res.data.info)
        }
      },
      /**页面切换 */
      switchPage(string){
        this.$router.push(string)
      },
      /**忘记密码弹窗显示切换 */
      changeForgetPasswordDialog(bool){
        this.forgetPasswordDialogShow = bool
        this.userLoginData.initData()
        clearInterval(this.forgetPasswordTimer)
        this.forgetPasswordTimer = null
        this.forgetPasswordTime = 0
      },
      /**忘记密码菜单子项点击事件 */
      forgetPasswordMenuItemClick(id){
        let obj = {
          'email' : UserInputNewModule.NEWFINDPASSWORDBYEMAIL(),
          'phone' : UserInputNewModule.NEWFINDPASSWORDBYPHONE()
        }
        this.forgetPasswordMenuSelect = id
        this.forgetPasswordInputData = obj[id]
        //清空数据
        this.userLoginData.initData()
      },
      /**获取找回密码验证码 */
      async getForgetPasswordCode(){
        let obj = {
          'email' : UserAxios.getEmailVerificationCode(this.userLoginData.getEmailVerityCodeAxiosBody),
          'phone' : UserAxios.getMobileVerificationCode(this.userLoginData.getPhoneVerityCodeAxiosBody)
        }
        let res = await obj[this.forgetPasswordMenuSelect]
        if(res.data.code === 1){
          this.$message.success('请在60S内填写')
          this.forgetPasswordTime = 60
          this.forgetPasswordTimer = setInterval(() => {
            if(this.forgetPasswordTime > 0 && this.forgetPasswordTime <= 60){
              this.forgetPasswordTime --
            }else{
              clearInterval(this.forgetPasswordTimer)
              this.forgetPasswordTimer = null
            }
          }, 1000)
        }else{
          this.$message.error(res.data.info)
        }
      },
      /**提交找回密码对应数据 */
      async submitForgetPassword(){
        let obj = {
          'email' : UserAxios.findPasswordBeEmail(this.userLoginData.getEmailFindPasswordAxiosBody),
          'phone' : UserAxios.findPasswordBeMobile(this.userLoginData.getPhoneFindPasswordAxiosBody)
        }
        let res = await obj[this.forgetPasswordMenuSelect]
        if(res.data.code === 1){
          this.$message.success(res.data.info)
          this.$router.replace('/index')
        }else{
          this.$message.error(res.data.info)
        }
      },
    },
    data(){
      return{
        /**用户登录数据 */
        userLoginData: new UserLogin(),
        /**用户登录输入数据 */
        userLoginInputData: UserInputNewModule.NEWUSERLOGININPUT(),
        /**是否需要手机验证码 */
        isNeedPhoneCode: false,
        /**手机验证码定时器 */
        phoneCodeTimer: null,
        phoneCodeTime: 0,
        /**忘记密码弹窗显示 */
        forgetPasswordDialogShow: false,
        /**忘记密码菜单选项 */
        forgetPasswordMenu: UserInputNewModule.NEWFINDPASSWORDMENU(),
        forgetPasswordMenuSelect: 'email',
        /**忘记密码输入项 */
        forgetPasswordInputData: UserInputNewModule.NEWFINDPASSWORDBYEMAIL(),
        /**忘记密码验证码定时器 */
        forgetPasswordTimer: null,
        forgetPasswordTime: 0,
      }
    },
    computed: {
      userLoginShowInputData(){
        return this.isNeedPhoneCode ? this.userLoginInputData : this.userLoginInputData.filter(e => e.data !== 'phoneVerityCode')
      }
    }
  }
</script>

<style scoped lang="scss">
  .login{
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-color: #f8f8ff;
    position: relative;
    &-content{
      // position: absolute;
      // top: 40%;
      // left: 20%;
      // transform: translate(-50%, -50%);
      margin: 100px auto;
      width: 500px;
      min-height: 400px;
      box-sizing: content-box;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &__title{
        color: #ff7f17;
        font-size: 20px;
        font-weight: bold;
        padding: 10px 5px 20px;
      }
      &-line{
        &__item{
          margin-bottom: 20px;
          display: flex;
        }
        &__input{
          width: 350px;
          height: 40px;
          font-size: 10px;
          outline: none;
          padding: 0 10px;
          border: 1px solid #e6e6e6;
          color: #8b8b8b;
          &--verityCode{
            width: 190px;
            margin-top: 10px;
          }
          &--verityPhone{
            width: 220px;
          }
        }
        &__btn{
          width: 120px;
          line-height: 38px;
          text-align: center;
          background-color: #fff;
          border: 1px solid #e6e6e6;
          font-size: 12px;
          color: #8b8b8b;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
        }
        &__img{
          width: 140px;
          height: 50px;
          margin: 0 10px;
          &:hover{
            cursor: pointer;
          }
        }
      }
      &-fun{
        width: 350px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        &__item{
          cursor: pointer;
          opacity: .8;
        }
      }
      &__btn{
        background-color: #19ACFD;
        color: #FFFFFF;
        padding: 10px;
        width: 350px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &-findpassword{
      padding: 10px 20px;
      &-menu{
        display: flex;
        border: 1px solid #e6e6e6;
        &__item{
          width: 250px;
          text-align: center;
          color: #898989;
          padding: 10px 0;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
          &--select{
            background-color: #00dfe3;
            color: white;
            &:hover{
              cursor: default;
              opacity: 1;
            }
          }
        }
      }
      &-line{
        display: flex;
        padding: 10px;
        line-height: 36px;
        &__btn{
          font-size: 12px;
          color: #00dfe3;
          text-align: center;
          width: 100px;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
        }
      }
      &__name{
        width: 150px;
        text-align: right;
        margin-right: 10px;
      }
      &__input{
        outline: none;
        padding: 0 10px;
        width: 270px;
        border: 1px solid rgb(117, 117, 117);
        &--verity{
          width: 170px;
        }
      }
      &-bottom{
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding: 20px 0 0;
      }
      &__btn{
        padding: 10px 20px;
        background: #00dfe3;
        color: white;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }

  .logo{
    width: 100%;
    min-width: 1440px;
    position: relative;
    background-color: #022028;
    text-align: start;
    padding: 1px 50px;
  }

  .login_info{
    display: flex;
    min-width: 340px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 100px 200px 0;
  }

  .login_title{
    /*color: #00dfe3;*/
    color: #ff7f17;
    min-width: 340px;
    font-size: 20px;
    font-weight: bold;
    padding: 10px 5px 20px;
    text-align: center;
  }

  .input_item{
    margin-bottom: 20px;
  }

  .input_box{
    width: 340px;
    height: 40px;
    font-size: 10px;
    outline: none;
    padding: 0 10px;
    border: 1px solid #e6e6e6;
    color: #8b8b8b;
  }

  .input_box::placeholder{
    color: #a5a5a5;
  }

  .login_content{
    width: 500px;
    height: 400px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .login_fun{
    width: 340px;
    display: flex;
    margin: 20px;
    justify-content: space-between;
  }

  .login_fun span{
    margin: 0 10px 0 0;
  }

  .login_fun span:hover{
    opacity: .8;
    cursor: pointer;
  }

  .fun_left{
    text-align: start;
  }

  .fun_right{
    text-align: end;
  }

  .login_btn_div{
    width: 340px;
    text-align: end;
    margin-top: 20px;
  }

  .login_btn{
    /*background-color: #00dfe3;*/
    background-color: #19ACFD;
    font-size: 14px;
    font-weight: bold;
    color: white;
    padding: 10px 20px;
    border: none;
    width: 100%;
    outline: none;
  }

  .login_btn:hover{
    cursor: pointer;
    opacity: .8;
  }

  .login_btn[disabled]{
    background-color: #cccccc;
  }

  .login_btn[disabled]:hover{
    cursor: initial;
    opacity: 1;
  }

  .find_password{
    margin: 20px;
    width: 500px;
    height: 350px;
    /*box-shadow: 0 0 5px #888888;*/
  }

  .find_password_title{
    font-size: 20px;
    text-align: center;
    padding: 10px;
    margin-bottom: 10px;
    color: #00dfe3;
    font-weight: bold;
  }

  .password_select{
    font-size: 16px;
    text-align: center;
    display: flex;
    border: 1px solid #e6e6e6;
  }

  .password_select div{
    flex: 1;
    padding: 10px;

  }

  .password_select div:hover{
    opacity: .8;
    cursor: pointer;
  }

  .is_select{
    background-color: #00dfe3;
    color: white;
  }

  .select_main{
    text-align: center;
    height: 100%;
    margin-top: 20px;
  }

  .select_input{
    display: flex;
    justify-content: center;
    line-height: 35px;
    margin: 10px 0 0 -10px;
  }

  .select_input div{
    width: 80px;
    font-size: 12px;
    color: #00dfe3;
  }

  .select_input div:hover{
    opacity: .8;
    cursor: pointer;
  }

  .select_input span{
    width: 100px;
    text-align: end;
    color: black;
    height: 35px;
  }

  .select_input_item{
    outline: none;
    padding: 0 10px;
    color: #898989;
    border: 1px solid #b1b1b1;
    font-size: 12px;
    width: 220px;
  }

  .select_input_item1{
    outline: none;
    padding: 0 10px;
    color: #898989;
    width: 140px;
    border: 1px solid #b1b1b1;
    font-size: 12px;
  }

  .find_password_btn{
    margin: 30px 0 0 0 ;
    text-align: end;
  }

  .find_password_btn button{
    background-color: #00dfe3;
    color: white;
    border: none;
    outline: none;
    padding: 10px 30px;
  }

  .find_password_btn button:hover{
    opacity: .8;
    cursor: pointer;
  }

  .input_info{
    position: relative;
  }

  .my_input{
    height: 40px;
    width: 340px;
    border: 1px solid #e6e6e6;
    margin: 0 0 15px 0;
    display: flex;
  }

  .my_sent_btn{
    width: 100px;
    line-height: 38px;
    text-align: center;
    background-color: #fff;
    border-left: 1px solid #e6e6e6;
    font-size: 12px;
    color: #8b8b8b;
  }

  .my_sent_btn1{
    width: 100px;
    line-height: 38px;
    background-color: #fff;
    border-left: 1px solid #e6e6e6;
    text-align: center;
    font-size: 12px;
    color: #8b8b8b;
  }

  .my_sent_btn:hover{
    opacity: .8;
    cursor: pointer;
  }

  .tip_main{
    font-size: 14px;
    font-weight: bold;
    width: 500px;
    padding: 20px;
    color: black;
  }

  .tip_btn{
    display: flex;
    justify-content: space-between;
  }

  .tip_btn button{
    background-color: #19ACFD;
    color: white;
    padding: 10px 0;
    width: 80px;
    text-align: center;
    border: none;
    outline: none;
    border-radius: 10px;
    margin: 10px 20px;
  }

  .tip_btn button:hover{
    cursor: pointer;
    opacity: .8;
  }

  .registered_input_1{
    height: 40px;
    margin: 10px 10px 0 0;
    width: 190px;
    border: 1px solid #e6e6e6;
    font-size: 12px;
    color: #8b8b8b;
    padding: 10px;
  }

  .verity_img{
    width: 140px;
    height: 50px;
    margin-bottom: -10px;
  }

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
    color: #a5a5a5;
}
</style>
